import { Avatar, AvatarProps } from '@mui/material';
import { mergeSx } from 'shared/_ui/utils'

function stringToColor(string: string) {
	let hash = 0;
	let i;

	/* eslint-disable no-bitwise */
	for (i = 0; i < string.length; i += 1) {
		hash = string.charCodeAt(i) + ((hash << 5) - hash);
	}

	let color = '#';

	for (i = 0; i < 3; i += 1) {
		const value = (hash >> (i * 8)) & 0xff;
		color += `00${value.toString(16)}`.slice(-2);
	}
	/* eslint-enable no-bitwise */

	return color;
}

function stringAvatar(name = '') {
	return {
		sx: { bgcolor: stringToColor(name) },
		children: `${name.split(' ')?.at(0)?.at(0) || ''}${name.split(' ')?.at(1)?.at(0) || ''}`,
	};
}

export default function UserAvatar(props: Omit<AvatarProps, 'children'> & { name?: string }) {
	const { name, ...rest } = props;
	const { sx, ...avatarProps } = stringAvatar(name);
	return <Avatar {...rest} sx={mergeSx(sx, rest.sx)} {...avatarProps} />;
}
